var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.061,
    height: 15.061,
    viewBox: "0 0 15.061 15.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-10050 -928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_85",
    "data-name": "Path 85",
    transform: "translate(10050 928)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6,0A5.6,5.6,0,1,1,0,5.6,5.6,5.6,0,0,1,5.6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.600000381469727 1.5 C 3.339250564575195 1.5 1.5 3.339250564575195 1.5 5.600000381469727 C 1.5 7.860750198364258 3.339250564575195 9.700000762939453 5.600000381469727 9.700000762939453 C 7.860750198364258 9.700000762939453 9.700000762939453 7.860750198364258 9.700000762939453 5.600000381469727 C 9.700000762939453 3.339250564575195 7.860750198364258 1.5 5.600000381469727 1.5 M 5.600000381469727 0 C 8.692790031433105 0 11.20000076293945 2.507210731506348 11.20000076293945 5.600000381469727 C 11.20000076293945 8.692790031433105 8.692790031433105 11.20000076293945 5.600000381469727 11.20000076293945 C 2.507210731506348 11.20000076293945 0 8.692790031433105 0 5.600000381469727 C 0 2.507210731506348 2.507210731506348 0 5.600000381469727 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M4.356,4.356,0,0",
    transform: "translate(10059.645 937.644)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDropdown);
export default __webpack_public_path__ + "static/media/searchDropdown.520e672ced5da00eed350727d114daff.svg";
export { ForwardRef as ReactComponent };